import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  body: { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: '12px' },
  title: {
    fontFamily: 'DIN-2014_Regular',
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    maxWidth: '50rem',
    overflow: 'hidden',
  },
  quantity: {
    fontFamily: 'DIN-2014_Regular',
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['fontSizeCaption-2'],
    color: colors.secondaryText,
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: anatomy['space-8'],
  },
  iconContainer: {
    padding: anatomy['space-4'],
    color: colors.tertiaryIcon,
    transition: 'color 0.2s ease-in-out',
    ':not(#__unused__) > button': {
      color: 'inherit',
    },
    ':hover': {
      color: colors.accentIcon,
    },
  },
  column: { display: 'flex', flexDirection: 'column', alignItems: 'start' },
});
